export class DataConstants {
  public static INVOICE_NUMBER_LENGHT: Number = 11;
  public static SPINNER_PATH: String = 'assets/images/spinner.gif';

  // validation error codes
  public static LABVAL_CODE_STATUS_INVALID: String = 'default.labOrder.status.invalid';
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/data/data-constants.ts